import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { AuthProvider } from "context/auth-context/auth.context";
import { PermissionsProvider } from "context/permissions-context/permissions.context";
import "./utils/i18n";

// Soft UI Context Provider
import { SoftUIControllerProvider } from "context";

let user = localStorage.getItem("user");
user = JSON.parse(user);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <SoftUIControllerProvider>
      <AuthProvider userData={user}>
        <PermissionsProvider>
          <App />
        </PermissionsProvider>
      </AuthProvider>
    </SoftUIControllerProvider>
  </BrowserRouter>
);
